const state = {
    hsCodeData:[],
    industryData:[],
    state_hsCodeDataTrade: {
        en: [],
        zh: []
    }
}
const getters = {
    hsCodeData: state=>{
        return state.hsCodeData
    },
    industryData: state=>{
        return state.industryData
    },
    getters_hsCodeDataTrade: state=>{
        return state.state_hsCodeDataTrade
    },
}
const mutations = {
    store_hsCodeData:(state,data)=>{
        state.hsCodeData = data
    },
    store_IndustryData:(state,data)=>{
        state.industryData = data
    },
    mutations_hsCodeDataTrade:(state,data)=>{
        state.state_hsCodeDataTrade = data
    },
}
export default {
    state,
    mutations,
    getters
  }